module.exports = __webpack_public_path__ + "static/media/Fogger.4163e953.webp";